export default __webpack_public_path__ + "assets/fonts/aa72fd5e3aba372ffe12d7e772303d2d.woff2";